import template from 'modal/product-create-registry.j2';

import { generate } from '../../../core/js/utils/componentUtils';

export function init(store, cr, overrides = {}) {
    const config = {
        firstRender: firstRender,
        name: 'modal.productCreateRegistry',
        template: template
    };

    return generate(config, store, cr, overrides);
}

function firstRender(store) {
    this.render(store, this);
}
